/**
 * This file provides compatibility exports for Material UI icons
 * that may be missing or having import issues
 */

import SvgIcon from '@mui/material/SvgIcon';

// AccountCircle icon
export const AccountCircle = (props) => (
  <SvgIcon {...props}>
    <path
      fill="white"
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
    />
  </SvgIcon>
);

// ExpandMore icon
export const ExpandMore = (props) => (
  <SvgIcon {...props}>
    <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
  </SvgIcon>
);

// Logout icon
export const Logout = (props) => (
  <SvgIcon {...props}>
    <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
  </SvgIcon>
);

// Menu icon
export const Menu = (props) => (
  <SvgIcon {...props}>
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
  </SvgIcon>
);

// Cancel icon
export const Cancel = (props) => (
  <SvgIcon {...props}>
    <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
  </SvgIcon>
);

// Visibility icon with gradient
export const Visibility = (props) => (
  <SvgIcon {...props} viewBox="0 0 25 24">
    <defs>
      <linearGradient
        id="paint0_linear_visibility"
        x1="16.6792"
        y1="24.7964"
        x2="-11.9804"
        y2="14.9312"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDB6CC" />
        <stop offset="0.49" stopColor="#D9E2EE" />
        <stop offset="1" stopColor="#DDEBF4" />
      </linearGradient>
    </defs>
    <path
      d="M12.5 4.00018C7.5 4.00018 3.23 7.11018 1.5 11.5002C3.23 15.8902 7.5 19.0002 12.5 19.0002C17.5 19.0002 21.77 15.8902 23.5 11.5002C21.77 7.11018 17.5 4.00018 12.5 4.00018ZM12.5 16.5002C9.74 16.5002 7.5 14.2602 7.5 11.5002C7.5 8.74018 9.74 6.50018 12.5 6.50018C15.26 6.50018 17.5 8.74018 17.5 11.5002C17.5 14.2602 15.26 16.5002 12.5 16.5002ZM12.5 8.50018C10.84 8.50018 9.5 9.84018 9.5 11.5002C9.5 13.1602 10.84 14.5002 12.5 14.5002C14.16 14.5002 15.5 13.1602 15.5 11.5002C15.5 9.84018 14.16 8.50018 12.5 8.50018Z"
      fill="url(#paint0_linear_visibility)"
    />
  </SvgIcon>
);

// VisibilityOff icon with gradient
export const VisibilityOff = (props) => (
  <SvgIcon {...props} viewBox="0 0 25 24">
    <defs>
      <linearGradient
        id="paint0_linear_visibility_off"
        x1="16.6792"
        y1="24.7964"
        x2="-11.9804"
        y2="14.9312"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDB6CC" />
        <stop offset="0.49" stopColor="#D9E2EE" />
        <stop offset="1" stopColor="#DDEBF4" />
      </linearGradient>
    </defs>
    <path
      d="M12.5 6.50018C15.26 6.50018 17.5 8.74018 17.5 11.5002C17.5 12.0102 17.4 12.5002 17.26 12.9602L20.32 16.0202C21.71 14.7902 22.81 13.2502 23.5 11.4902C21.77 7.11018 17.5 4.00018 12.5 4.00018C11.23 4.00018 10.01 4.20018 8.86 4.57018L11.03 6.74018C11.5 6.60018 11.99 6.50018 12.5 6.50018ZM3.21 3.16018C2.82 3.55018 2.82 4.18018 3.21 4.57018L5.18 6.54018C3.56 7.83018 2.27 9.53018 1.5 11.5002C3.23 15.8902 7.5 19.0002 12.5 19.0002C14.02 19.0002 15.47 18.7002 16.81 18.1802L19.53 20.9002C19.92 21.2902 20.55 21.2902 20.94 20.9002C21.33 20.5102 21.33 19.8802 20.94 19.4902L4.63 3.16018C4.24 2.77018 3.6 2.77018 3.21 3.16018ZM12.5 16.5002C9.74 16.5002 7.5 14.2602 7.5 11.5002C7.5 10.7302 7.68 10.0002 7.99 9.36018L9.56 10.9302C9.53 11.1102 9.5 11.3002 9.5 11.5002C9.5 13.1602 10.84 14.5002 12.5 14.5002C12.7 14.5002 12.88 14.4702 13.07 14.4302L14.64 16.0002C13.99 16.3202 13.27 16.5002 12.5 16.5002ZM15.47 11.1702C15.32 9.77018 14.22 8.68018 12.83 8.53018L15.47 11.1702Z"
      fill="url(#paint0_linear_visibility_off)"
    />
  </SvgIcon>
);

// Required for module.exports style imports
const icons = {
  AccountCircle,
  ExpandMore,
  Logout,
  Menu,
  Cancel,
  Visibility,
  VisibilityOff,
};

// Make icons available as both named exports and default export
export default icons;
